export default "__VITE_ASSET__BzzZChHY__"